import { Typography, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { LoadingIcon } from "bc-front-sagacomponents";
import illustration from "../../images/illustration-depannage.png";
import logo from "../../images/logo-saga.png";
import styles from "./style";

interface Props {
  classes?: any;
}
const CreationComptePage = (props: Props) => {
  const { classes } = props;

  const [params, setParams] = useState<
    { numeroAdhesion: string | null; token?: string | null } | undefined
  >();

  useEffect(() => {
    const numeroAdhesion = new URL(window.location.href).searchParams.get(
      "numeroAdhesion"
    );
    const token = new URL(window.location.href).searchParams.get("token");
    setParams({
      numeroAdhesion,
      token,
    });
  }, [window.location.href]);
  const { response, fetching, error } = useFetch<void>(
    params,
    "signerAdhesion",
    params && params.numeroAdhesion && params.token ? true : false
  );
  if (fetching) {
    return <LoadingIcon />;
  } else
    return (
      <div className={classes.containerConfirmation}>
        <img className={classes.logo} src={logo} alt="Logo" />
        {response && (
          <div className={classes.title}>
            <Typography variant="h2">
              Demande de signature <strong>confirmée</strong>
            </Typography>
          </div>
        )}

        <div className={classes.container}>
          {response && (
            <Typography variant="h4">
              Un code de confirmation vient de vous être envoyé par sms.
              <br /> Merci de saisir ce code dans l’interface de votre
              concessionnaire pour finaliser la signature de votre contrat
            </Typography>
          )}
          {error && error.response && error.response.status === 401 && (
            <Typography variant="h3">
              Le token a expiré, veuillez relancer une procédure de signature.
            </Typography>
          )}
          {((error && error.response && error.response.status !== 401) ||
            (error && !error.response)) && (
            <Typography variant="h3">Une erreur est survenue</Typography>
          )}
          <img className={classes.illu} src={illustration} alt="Inscription" />
        </div>
      </div>
    );
};

export default withStyles(styles)(CreationComptePage);
